<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M8.77011 28.75C9.15956 21.5049 15.1577 15.75 22.5 15.75C29.8423 15.75 35.8404 21.5049 36.2299 28.75H8.77011Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
